import React, { useEffect, useState } from "react";
import { apiClient, formatApiError, useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { CalendarClock, CheckCircle2 } from "lucide-react";
import { fmtUsd } from "./FinanceLayout";
import { DEBT_CARD, canEditCard } from "@/lib/placement";

export const ExhibitPill = ({ bill }) => bill.exhibit ? (
  <span data-testid={`bill-exhibit-${bill.id}`} className={`mono-body text-[9px] uppercase tracking-widest px-1.5 py-0.5 ${bill.exhibit === "A" ? "bg-sky-500/15 text-sky-300" : "bg-amber-500/15 text-amber-300"}`}>
    {bill.exhibit_label}{bill.amount_needed ? " · amount needed" : ""}{bill.autopay === true ? " · auto-pay" : bill.autopay === false ? " · manual" : ""}
  </span>
) : bill.classification_label ? (
  <span data-testid={`bill-class-${bill.id}`} className="mono-body text-[9px] uppercase tracking-widest px-1.5 py-0.5 bg-teal-500/15 text-teal-300">{bill.classification_label} · auto-draft</span>
) : null;

export const CutoverCard = ({ onDone }) => {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const sa = canEditCard(user, DEBT_CARD);

  useEffect(() => { if (sa) apiClient.get("/fin/cutover/2026-11").then((r) => setS(r.data)).catch(() => {}); }, [sa]);
  if (!sa || !s) return null;

  const go = async () => {
    setBusy(true);
    try { const r = await apiClient.post("/fin/cutover/2026-11/run"); setS(r.data); toast.success(`Cutover set up · ${r.data.bills_created} debt bills created`); onDone?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  if (s.done && s.up_to_date) return (
    <div className="card-industrial p-4 mb-6 flex flex-wrap items-center gap-3 text-sm" data-testid="cutover-done">
      <CheckCircle2 size={16} className="text-emerald-400" />
      <span>Nov 1, 2026 cutover is set up: TEA-First Reliance ...1403 {s.account?.is_primary ? "is the primary account" : "becomes primary on Nov 1"} · {s.pmc_partners.length} PMC partners · {s.debts.length} debts</span>
      <span className="text-nex-muted text-xs">Exhibit A {fmtUsd(s.monthly_total.A)}/mo · Exhibit B {fmtUsd(s.monthly_total.B)}/mo · Operating overhead {fmtUsd(s.overhead_total || 0)}/mo</span>
      <span className="text-nex-muted text-xs" data-testid="cutover-balance-total">Balances: A {fmtUsd(s.balance_total.A)} · B {fmtUsd(s.balance_total.B)} · Total {fmtUsd(s.balance_total.A + s.balance_total.B)}</span>
    </div>
  );
  return (
    <div className="card-industrial p-4 mb-6 flex flex-col md:flex-row md:items-center justify-between gap-3" data-testid="cutover-card">
      <div className="text-sm">
        <div className="flex items-center gap-2 font-semibold"><CalendarClock size={15} /> Nov 1, 2026 financial cutover</div>
        <p className="text-nex-muted text-xs mt-1">Adds TEA-First Reliance ...1403 ($1,875.00 opening deposit, primary from Nov 1), keeps Citizens for reconciliation, adds the 3 PMC partner records, starts distribution tracking and creates the monthly debt bills (Exhibit A Founding Debt and Exhibit B Active Lines).</p>
      </div>
      <button type="button" disabled={busy} onClick={go} className="tick-btn-primary text-xs !py-2 !px-3 shrink-0" data-testid="cutover-run-btn">{busy ? "Setting up…" : s.done ? "Apply updated debt schedule" : "Run cutover setup"}</button>
    </div>
  );
};
